import { render, staticRenderFns } from "./LadaItemCard.vue?vue&type=template&id=c8fb5d24&"
import script from "./LadaItemCard.vue?vue&type=script&lang=js&"
export * from "./LadaItemCard.vue?vue&type=script&lang=js&"
import style0 from "./LadaItemCard.vue?vue&type=style&index=0&id=c8fb5d24&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports